import { getUser } from "@/utils/User";

// default params to send to backend
export const defaultParams = (language = null, user = null) => {
    const params = {};

    if (language) {
        params.language = language;
    }

    if (user && user?.company) {
        params.companyuser = user?.company;
    }

    // check if impersonating
    const userOriginal = getUser(true);
    if (userOriginal && userOriginal?.id) {
        params.useroriginal = userOriginal?.id;
    }

    params.urlfrom = window.location.href;

    return params;
};
